import { isDev } from "@/helpers"
import { DEV_API_URL, PROD_API_URL } from "."

const baseUrl = isDev() ? DEV_API_URL : PROD_API_URL

export async function login(username: string, password: string) {
    const response = await fetch(`${baseUrl}/auth/login`, {
        method: "post",
        body: new URLSearchParams({ username, password }),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    })
    return response.json()
}

export async function signup(email: string, password: string, displayName: string) {
    const response = await fetch(`${baseUrl}/auth/signup`, {
        method: "post",
        body: new URLSearchParams({ email, password, displayName }),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    })
    return response.json()
}

export async function usernameAvailable(email: string): Promise<boolean> {
    const response = await fetch(`${baseUrl}/auth/username-available`, {
        method: "post",
        body: new URLSearchParams({ email }),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    })
    return response.json()
}

export function logout() {
    return new Promise((resolve) => {
        window.localStorage.removeItem("token")
        location.reload()
        resolve(true)
    })
}
